import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

export default {
  set_username (username) {
    Vue.localStorage.set('username', username)
  },
  get_username () {
    return Vue.localStorage.get('username', null)
  },
  set_password (password) {
    Vue.localStorage.set('password', password)
  },
  get_password () {
    let password = Vue.localStorage.get('password')
    return password
  },
  remove_password () {
    Vue.localStorage.remove('password')
  },
  set_project (project) {
    Vue.localStorage.set('project', JSON.stringify(project))
  },
  get_project () {
    let project = Vue.localStorage.get('project', undefined)
    if (project) {
      project = JSON.parse(project)
    }
    return project
  },
  remove_project () {
    Vue.localStorage.remove('project')
  },
  set_profile (profile) {
    Vue.localStorage.set('profile', JSON.stringify(profile))
  },
  get_profile () {
    let profile = Vue.localStorage.get('profile', undefined)
    if (profile) {
      profile = JSON.parse(profile)
    }
    return profile
  },
  remove_profile () {
    Vue.localStorage.remove('profile')
  },
  set_token (token) {
    Vue.localStorage.set('token', token)
  },
  get_token () {
    let token = Vue.localStorage.get('token', undefined)
    return token
  },
  remove_token () {
    Vue.localStorage.remove('token')
  },
  set_lang (lang) {
    Vue.localStorage.set('lang', lang)
  },
  get_lang () {
    let lang = Vue.localStorage.get('lang', undefined)
    if (!lang) {
      const navLang = navigator.language
      console.log(navLang, 'navLang')

      lang = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'vi') ? navLang : 'en-US'
    }

    return lang
  }
}



// WEBPACK FOOTER //
// ./src/storage/index.js